import React, { useState } from 'react';
import { Row, Col, Card, Collapse, Button } from 'reactstrap'; // or '@availity/reactstrap-validation' if you're using that package

const GenericApplicationDetails = ({ data }) => {
  const [isOpen, setisOpen] = useState(false)
  const toggle = () => setisOpen(!isOpen)
  return (
    <>
    <Card>
      <Button color='primary' onClick={toggle}>{isOpen? "Hide Application Details" : "Show Application Details" }</Button>
      <Collapse isOpen={isOpen}>
      <br></br>
    <Row>
      
      {data.map((item, index) => (
        <Col md="6" key={index} className="detail-item">
          <h6>{item.title}</h6>
          {item.is_text_area ? (
            <textarea style={{ width: '100%' }} rows={6}  value={item.value} readOnly />
          ) : (
            <p>{item.value}</p>
          )}
        </Col>
      ))}
      <hr></hr>
    </Row>
    </Collapse>
    </Card>
    </>
  );
};

export default GenericApplicationDetails;
